import type { Company } from '@/types/directory/Company';
import type { OptionProps } from '@amelio/ui-library';

import { CompanyAttribute } from '@/constants/directory/CompanyAttribute';
import { getCompanyAttributeList } from '@/utils/company';

const EXCLUDED_ATTRIBUTES: string[] = [CompanyAttribute.AGE_GROUPS, CompanyAttribute.TENURES];

export const buildCompanyAttributeOptions = (companyInformation?: Company): OptionProps[] => {
    const attributes = getCompanyAttributeList(companyInformation);

    return Object.entries(attributes)
        .filter(([key]) => !EXCLUDED_ATTRIBUTES.includes(key))
        .map(([, attribute]) => ({ label: attribute.name, value: attribute.name }));
};
